import type {
  ScInstallInfo,
  ScPriorityDef,
  ScPriorityKey,
  ScSchemaItem,
  ScStatusDef,
  ScStatusKey,
  ScValidation,
} from './types';

export const SC_INSTALL: ScInstallInfo = {
  status: 'installed',
  installedDate: 'March 2, 2026',
  lastPing: '2 minutes ago',
  pagesDetected: 14,
};

export const SC_STATUS: Record<ScStatusKey, ScStatusDef> = {
  active: { label: 'Active', tone: 'success' },
  warning: { label: 'Partial', tone: 'gold' },
  missing: { label: 'Not deployed', tone: 'neutral' },
  error: { label: 'Error', tone: 'terra' },
};

export const SC_PRIORITY: Record<ScPriorityKey, ScPriorityDef> = {
  essential: { label: 'Essential', tone: 'terra' },
  important: { label: 'Important', tone: 'gold' },
  recommended: { label: 'Recommended', tone: 'gold' },
  nice_to_have: { label: 'Nice to have', tone: 'neutral' },
};

export const SC_SCHEMAS: ScSchemaItem[] = [
  {
    id: 'localbusiness',
    name: 'LocalBusiness / Dentist',
    status: 'active',
    priority: 'essential',
    description:
      'Core identity schema. Tells Google what kind of business you are and where.',
    lastUpdated: '3 days ago',
    deployedOn: 'All pages (site-wide)',
    source: 'PMS + Settings',
  },
  {
    id: 'aggregatereview',
    name: 'AggregateRating + Reviews',
    status: 'active',
    priority: 'essential',
    description: 'Shows your star rating directly in Google search results. Major CTR lift.',
    lastUpdated: '6 hours ago',
    deployedOn: 'Homepage, service pages',
    source: 'GBP (synced hourly)',
  },
  {
    id: 'faqpage',
    name: 'FAQPage',
    status: 'active',
    priority: 'essential',
    description:
      'Expands your search result to show common Q&As directly. Takes up more screen space.',
    lastUpdated: '1 week ago',
    deployedOn: 'Service pages (8 pages)',
    source: 'ELVA content engine',
  },
  {
    id: 'service',
    name: 'Service (per treatment)',
    status: 'active',
    priority: 'essential',
    description: 'Marks up each service you offer so Google can match you to specific searches.',
    lastUpdated: '2 days ago',
    deployedOn: '8 service pages',
    source: 'PMS service codes + ELVA',
  },
  {
    id: 'person',
    name: 'Person (Doctor profiles)',
    status: 'active',
    priority: 'recommended',
    description: 'Doctor / dentist profile markup. Helps with "Dr. [Name]" searches.',
    lastUpdated: '2 weeks ago',
    deployedOn: 'About / Team pages',
    source: 'Settings + ELVA content',
  },
  {
    id: 'breadcrumb',
    name: 'BreadcrumbList',
    status: 'warning',
    priority: 'recommended',
    description: 'Navigation hierarchy shown below your URL in search results.',
    lastUpdated: '1 month ago',
    deployedOn: '3 of 14 pages',
    source: 'ELVA auto-generated',
    issue: 'Not deployed on 11 pages — ELVA will auto-deploy on the next scan.',
  },
  {
    id: 'medical',
    name: 'MedicalCondition (for content)',
    status: 'missing',
    priority: 'nice_to_have',
    description:
      'Marks up dental condition information on educational pages. Nice for SEO depth.',
    deployedOn: 'Not deployed',
    source: '—',
  },
];

export const SC_VALIDATION: ScValidation = {
  valid: 5,
  warnings: 1,
  errors: 0,
  lastValidated: '2 hours ago',
  issues: [{ schema: 'BreadcrumbList', message: 'Missing on 11 of 14 pages', severity: 'warning' }],
};

export const SC_FAQS = [
  'How much do dental implants cost in NYC?',
  'How long does the implant process take?',
  'Does insurance cover dental implants?',
];

export const SC_SITELINKS = ['Services', 'About Us', 'Patient Reviews', 'Book Appointment'];
